import React from 'react'
import close from '../assets/images/close.svg'

const DeleteConfirmationPopup = ({ showDeletePopup, setShowDeletePopup, title, reference, confirmDelete, description, error = "", isLoading = false }) => {
    return (
        <>
            {showDeletePopup && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box delete-popup" ref={reference}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowDeletePopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>
                            Delete {title}
                        </div>
                        <p className='popupDesc'>{description}</p>
                        {error !== "" && error && <p className='error-message'>{error}</p>}
                        <div className="popup-actions">
                            <button className="cancel-btn" onClick={() => setShowDeletePopup(false)}>Cancel</button>
                            <button className="save-btn delete-btn" onClick={() => {
                                confirmDelete();
                            }}>
                                {isLoading ?
                                    <div className={`ringLoader loaderContinue`}></div>
                                    :
                                    'Delete'
                                }
                            </button>
                        </div>
                    </div>
                </>
            )}

        </>
    )
}

export default DeleteConfirmationPopup